import React, { useContext, useState } from 'react';
import { Button } from '@mui/material';
import InputValidatorField from '../../../common/components/Inputs/InputValidatorField';
import { IsValidPassword } from '../../../../utils/Validators';
import { ThemeContext } from 'styled-components';
import WithActions from "../../../common/components/Wrappers/WithActions";
import InputWithActions from "../../../common/components/Inputs/InputWithActions";
import InputEmail from "../../../common/components/Inputs/InputEmail";
import InputPassword from "../../../common/components/Inputs/InputPassword";
import ButtonPrimary from "../../../common/components/Buttons/ButtonPrimary";
import Box from "@mui/material/Box";
import DisabledFormState from "../../../common/components/Wrappers/DisabledFormState";

const PasswordConfirmationForm = ({
    onSubmit,
    onChangeAuthForm,
    validatePasswordMatch,
    onLoginError,
    isLoading = false,
    disabled = false,
    hidden = false
}) => {
    const theme = useContext(ThemeContext);
    const [passwordMismatchError, setPasswordMismatchError] = useState(false);

    const handlePasswordChange = (e) => {
        // Clear error state when user starts typing
        if (passwordMismatchError) {
            setPasswordMismatchError(false);
        }
        onChangeAuthForm(e);
    };

    if (disabled) {
        return <DisabledFormState message="Confirmed" tooltip="Password Confirmed" />
    }

    return (
        <Box
            component="form"
            onSubmit={(e) => {
                e.preventDefault();
                if (validatePasswordMatch && !validatePasswordMatch()) {
                    // Handle password mismatch error
                    setPasswordMismatchError(true);
                    if (onLoginError) {
                        onLoginError('Passwords do not match');
                    }
                    return;
                }
                setPasswordMismatchError(false);
                onSubmit();
            }}
            sx={{
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
                // border: isActive ? '2px solid #1976d2' : '1px solid #ccc',
                borderRadius: '8px',
                margin: '8px 0',
                // backgroundColor: isActive ? 'rgba(25, 118, 210, 0.05)' : 'transparent',
                transition: 'all 0.3s ease'
            }}
        >
            <WithActions
                disabled={disabled || isLoading}
                showSuccessButton={disabled}
                isVisible={!hidden}
                successTooltip="confirmed"
                inputType="text"
                forceSpacing={true}
                fullWidth
            >
                <InputPassword
                    name="password"
                    handleChange={handlePasswordChange}
                    error={passwordMismatchError}
                    tooltipEnabled={passwordMismatchError}
                    requirementsText={[
                        "",
                        <div>
                            Password must include:
                            <br />* 12 - 36 Characters
                            <br />* Uppercase & Lowercase letters
                            <br />* Numbers
                            <br />* One special character: ^$*.[]{}()?-"!@#%&/\,':;|_~`+=
                        </div>,
                        ""
                    ]}
                    autoComplete="new-password"
                />
            </WithActions>
            <br />
            <WithActions
                disabled={disabled || isLoading}
                showSuccessButton={disabled}
                isVisible={!disabled}
                inputType="text"
                forceSpacing={true}
                fullWidth
            >
                <InputPassword
                    name="confirmPassword"
                    handleChange={handlePasswordChange}
                    error={passwordMismatchError}
                    tooltipEnabled={passwordMismatchError}
                    requirementsText={[
                        "",
                        <div>
                            Passwords must match
                        </div>,
                        ""
                    ]}
                    autoComplete="password"
                />
            </WithActions>
            <br />
            <br />
            {(!disabled) && (
            <WithActions forceSpacing={true} isButton={true}>
            <ButtonPrimary
                type="submit"
                disabled={isLoading}
            >
                Confirm
            </ButtonPrimary>
            </WithActions>
            )}
        </Box>
    );
};

export default PasswordConfirmationForm;
